import React, { useEffect, useState } from "react";
import {
  Alert,
  Box,
  Chip,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { get } from "src/utils/networkUtils";
import { fDateTime } from "src/utils/formatTime";

export default function GolfJackpotHistory() {
  const [periods, setPeriods] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    get("/admin/minigames/golf-jackpots")
      .then((response) => {
        if (!cancelled) setPeriods(response.periods ?? []);
      })
      .catch((err) => {
        if (!cancelled) setError(err.message || "Failed to load jackpot periods");
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", p: 3 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return <Alert severity="error" sx={{ m: 2 }}>{error}</Alert>;
  }

  return (
    <Box sx={{ mt: 2, p: 2 }}>
      <Typography variant="h6" gutterBottom>
        Jackpot Periods
      </Typography>
      <Typography variant="body2" sx={{ color: "text.secondary", mb: 2 }}>
        Each play has one roll at the current day&apos;s chance. A day is each
        24 hours from the period&apos;s start date. A win starts a new period.
      </Typography>

      {periods.length === 0 ? (
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          No jackpot periods yet.
        </Typography>
      ) : (
        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Status</TableCell>
                <TableCell>Start Date</TableCell>
                <TableCell>Start Amount</TableCell>
                <TableCell>Jackpot</TableCell>
                <TableCell>Day</TableCell>
                <TableCell>Probability</TableCell>
                <TableCell>Winner</TableCell>
                <TableCell>Won At</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {periods.map((period) => (
                <TableRow key={period.minigameGolfJackpotPeriodId}>
                  <TableCell>
                    {period.isOngoing ? (
                      <Chip label="Ongoing" color="success" size="small" />
                    ) : period.winnerUserId ? (
                      <Chip label="Won" color="info" size="small" />
                    ) : (
                      <Chip label="Closed" size="small" />
                    )}
                  </TableCell>
                  <TableCell>{fDateTime(period.startDate)}</TableCell>
                  <TableCell>{period.startAmount?.toLocaleString()}</TableCell>
                  <TableCell>
                    {period.currentAmount != null
                      ? period.currentAmount.toLocaleString()
                      : "--"}
                  </TableCell>
                  <TableCell>{period.currentDay ?? "--"}</TableCell>
                  <TableCell>
                    {period.currentProbability != null
                      ? `${period.currentProbability}%`
                      : "--"}
                  </TableCell>
                  <TableCell>
                    {period.winnerUserId ? (
                      <a href={`/dashboard/profile?user_id=${period.winnerUserId}`}>
                        {period.winnerUserId}
                      </a>
                    ) : (
                      "--"
                    )}
                  </TableCell>
                  <TableCell>
                    {period.winnerDate ? fDateTime(period.winnerDate) : "--"}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
}
